import { createSlice } from "@reduxjs/toolkit";

export const searchBranchesSlice = createSlice({
  name: "searchBranches",
  initialState: {
    searchData: [],
    partnerList: [],
    branchList: [],
    searchField: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : null,
      partnerId: "-2",
      partnerBranchId: "-2",
    },
  },
  reducers: {
    setSearchFieldReducer: (state, actions) => {
      const valueName = Object.keys(actions.payload);
      const tempObj = state.searchField;
      tempObj[valueName[0]] = actions.payload[valueName[0]];
      state.searchField = tempObj;
    },
    getPartnersReducer: (state, actions) => {
      state.partnerList = actions.payload;
    },
    getBranchReducer: (state, actions) => {
      state.branchList = actions.payload;
    },
    setSearchDataReducer: (state, actions) => {
      state.searchData = actions.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getPartnersReducer,
  getBranchReducer,
  setSearchFieldReducer,
  setSearchDataReducer,
} = searchBranchesSlice.actions;

export default searchBranchesSlice.reducer;
